console.log("init Proteus treatments -- v1.05");

// PDP Mobile carousel arrows
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-gallery--mobile-arrows').forEach(function (gallery) {
    const carousel = gallery.querySelector('media-carousel');
    const prevBtn = gallery.querySelector('.carousel-arrow--prev');
    const nextBtn = gallery.querySelector('.carousel-arrow--next');

    if (!carousel || !prevBtn || !nextBtn) return;

    function getVisibleMediaItems() {
      return Array.from(
        carousel.querySelectorAll('.product-gallery__media')
      ).filter(function (el) {
        return el.style.display !== 'none' && !el.classList.contains('hidden');
      });
    }

    function getCurrentIndex() {
      const media = getVisibleMediaItems();
      const rect = carousel.getBoundingClientRect();
      const center = rect.left + rect.width / 2;
      let best = 0, bestDist = Infinity;
      for (let i = 0; i < media.length; i++) {
        const r = media[i].getBoundingClientRect();
        if (r.width === 0) continue;
        const d = Math.abs(r.left + r.width / 2 - center);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    function updateArrowState() {
      const idx = getCurrentIndex();
      const total = getVisibleMediaItems().length;
      prevBtn.disabled = idx <= 0;
      nextBtn.disabled = idx >= total - 1;
    }

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const idx = getCurrentIndex();
      if (idx <= 0) return;
      const media = getVisibleMediaItems();
      carousel.scrollTo({ left: media[idx - 1].offsetLeft, behavior: 'smooth' });
      setTimeout(updateArrowState, 350);
    });

    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const idx = getCurrentIndex();
      const media = getVisibleMediaItems();
      if (idx >= media.length - 1) return;
      carousel.scrollTo({ left: media[idx + 1].offsetLeft, behavior: 'smooth' });
      setTimeout(updateArrowState, 350);
    });

    carousel.addEventListener('scroll', function () {
      updateArrowState();
    }, { passive: true });

    // Reset on variant change
    gallery.addEventListener('variant:change', function () {
      setTimeout(updateArrowState, 100);
    });

    // Also hook into alt2's custom variant update
    document.addEventListener('variant:change', function () {
      setTimeout(updateArrowState, 150);
    });

    updateArrowState();
  });
});

// Fix: carousel height patch
// BaseCarousel._adjustHeight sets max-height:0 when selectedSlide is hidden
(function() {
  function patchCarousel() {
    var carousel = document.querySelector('media-carousel');
    if (!carousel) return false;

    // Patch the prototype (catches future calls)
    var proto = Object.getPrototypeOf(
      Object.getPrototypeOf(
        Object.getPrototypeOf(carousel)
      )
    );

    if (!proto || !proto.hasOwnProperty('_adjustHeight')) return false;

    var original = proto._adjustHeight;

    proto._adjustHeight = function() {
      if (!this.hasAttribute('adaptive-height')) return;

      var slide = this.selectedSlide;

      if (!slide || slide.clientHeight === 0) {
        var items = this.items || [];
        for (var i = 0; i < items.length; i++) {
          if (items[i].clientHeight > 0) {
            slide = items[i];
            break;
          }
        }
      }

      if (slide && slide.clientHeight > 0 && slide.clientHeight !== this.clientHeight) {
        this.style.maxHeight = slide.clientHeight + 'px';
      }
    };

    // Clean up damage from the unpatched first call
    function fixIfBroken() {
      if (carousel.style.maxHeight === '0px' || carousel.offsetHeight === 0) {
        carousel.style.maxHeight = '';
        carousel._adjustHeight();
        
        // If still 0, images haven't loaded yet — wait for them
        if (carousel.style.maxHeight === '0px' || carousel.offsetHeight === 0) {
          carousel.style.maxHeight = '';
        }
      }
    }

    // Run cleanup immediately
    fixIfBroken();

    // Run again after images start loading
    var firstImg = carousel.querySelector(
      '.product-gallery__media:not(.hidden) img'
    );
    if (firstImg) {
      if (firstImg.complete) {
        fixIfBroken();
      } else {
        firstImg.addEventListener('load', fixIfBroken);
      }
    }

    // Safety nets for slow loads
    setTimeout(fixIfBroken, 200);
    setTimeout(fixIfBroken, 500);
    setTimeout(fixIfBroken, 1500);

    // Watch for it happening again (resize, variant switch, etc.)
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'style' && carousel.style.maxHeight === '0px') {
          carousel.style.maxHeight = '';
          carousel._adjustHeight();
          if (carousel.style.maxHeight === '0px') {
            carousel.style.maxHeight = '';
          }
        }
      });
    });
    observer.observe(carousel, { attributes: true, attributeFilter: ['style'] });

    return true;
  }

  // Try to patch as early as possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Try immediately, then retry
      if (!patchCarousel()) setTimeout(patchCarousel, 50);
    });
  } else {
    if (!patchCarousel()) setTimeout(patchCarousel, 50);
  }
})(); // End Fix: carousel height patch

// set default checkout upsell
if(!window.sessionStorage.getItem("Proteus Checkout Upsell")){
  window.sessionStorage.setItem("Proteus Checkout Upsell", "default-upsell");
  gtm_add_cartAttribute("proteus_checkout_upsell_visibility", "default-upsell");
}

function checkVariantAndTogglePrice() {
  const urlParams = new URLSearchParams(window.location.search);
  const currentVariant = urlParams.get('variant');
  const isFirewoodPage = window.location.pathname.includes('/products/firewood');
  const shouldShowPrice = isFirewoodPage && currentVariant === '43338487693357';
  
  // Remove existing style if it exists
  const existingStyle = document.getElementById('price-toggle-style');
  if (existingStyle) {
    existingStyle.remove();
  }
  
  if (!shouldShowPrice) {
    document.querySelector('body').insertAdjacentHTML("afterbegin", `
      <style id="price-toggle-style">
      .product-info__price{
        display: none;
      }
      </style>  
    `);
  }
}

waitForElement('.shopify_subscriptions_app_container').then(subscription_app => {
  // Initial check
  checkVariantAndTogglePrice();
  
  // Listen for variant changes
  document.addEventListener('variant:change', checkVariantAndTogglePrice);
  
  // Also listen for URL changes (pushstate/popstate)
  window.addEventListener('popstate', checkVariantAndTogglePrice);
  
}).catch();
// support for [BRE-09] PP upsells

/* 
LIDS (prod id: 6578299830317)  
const x19_lid: 39397496324141
const x24_lid: 39397502484525
const x30_lid: 39397505990701

PITS (prod_id: 7219796508717)
X19 / Corten: 41234257870893
X19 / Stainless: 41234257903661
X24 / Corten: 41234325700653
X24 / Stainless: 41234325733421
X30 / Corten: 41234325766189
X30 / Stainless: 41234325798957
X42 / Corten: 41860588306477
X42 / Stainless: 4186059574481
*/

// mapping PIT variant IDs → their matching LID
// Map PIT variant IDs → corresponding LID (product + variant)
const pit_lid_map = {
  // X19 pits
  41234257870893: { prod: 6578299830317, var: 39397496324141 },
  41234257903661: { prod: 6578299830317, var: 39397496324141 },

  // X24 pits
  41234325700653: { prod: 6578299830317, var: 39397502484525 },
  41234325733421: { prod: 6578299830317, var: 39397502484525 },

  // X30 pits
  41234325766189: { prod: 6578299830317, var: 39397505990701 },
  41234325798957: { prod: 6578299830317, var: 39397505990701 },

  // X42 pits: add mapping when you have the LID(s)
  // 41860588306477: { prod: 6578299830317, var: ??? },
  // 4186059574481: { prod: 6578299830317, var: ??? },
};

document.addEventListener("cart:change", async (event) => {
  window.cart_data = event.detail.cart;

  const lids_to_add = new Set();
  const prods_to_add = new Set();

  for (const item of window.cart_data.items) {
    const match = pit_lid_map[item.variant_id];
    if (match) {
      lids_to_add.add(String(match.var));
      prods_to_add.add(String(match.prod));
    }
  }

  // Build CSV strings; if no matches, set to "none"
  const pp_var_ids  = lids_to_add.size ? Array.from(lids_to_add).join(",") : "none";
  const pp_prod_ids = prods_to_add.size ? Array.from(prods_to_add).join(",") : "none";

  // Desired attributes payload (strings only)
  const desiredAttrs = {
    pp_multi_offer: "true",
    pp_var_ids,
    pp_prod_ids,
    pp_coll_ids: "none",
    pp_discount_amount: "15",
    pp_discount_type: "percentage",
  };

  // (Optional) Skip network call if nothing changes
  const curr = window.cart_data.attributes || {};
  const unchanged =
    curr.pp_multi_offer === desiredAttrs.pp_multi_offer &&
    curr.pp_var_ids === desiredAttrs.pp_var_ids &&
    curr.pp_prod_ids === desiredAttrs.pp_prod_ids &&
    curr.pp_coll_ids === desiredAttrs.pp_coll_ids &&
    curr.pp_discount_amount === desiredAttrs.pp_discount_amount &&
    curr.pp_discount_type === desiredAttrs.pp_discount_type;

  if (unchanged) return;

  try {
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ attributes: desiredAttrs }),
    });
    const data = await res.json();
    console.log("Cart attributes updated:", data?.attributes ?? data);
  } catch (err) {
    console.error("Error updating cart:", err);
  }
});


if(getParam("cart") == "open"){
  waitForElement('[aria-controls="cart-drawer"]').then(cart_trigger => {
    cart_trigger.click();
  }).catch()
}

/* START support for [BRE-01] */
let free_burger_press = () => {
  
  window.sessionStorage.setItem("[BRE-01] activate Burger Press GWP", true);
  let burger_press_var_id = 42490257834029;

  // logic for all NOT /cart pages
  let assess_cart = (cart_total) => {

    waitUntil(() => {
      return typeof window.cart_data != "undefined" && typeof window.cart_data.items != "undefined";
    }).then(() => {

      let burger_press_in_cart = window.cart_data.items.some(item => item.title.toLowerCase().includes('breeo burger press'));
      if(!burger_press_in_cart && window.cart_data.total_price >= 39800 && !window.sessionStorage.getItem("[BRE-01] Burger Press GWP added")){
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: burger_press_var_id, 
              quantity: 1
            }]
          })
        }).then(response => response.json()).then(cart => {
          console.log("assess_cart item added"),
          window.sessionStorage.setItem("[BRE-01] Burger Press GWP added", true);
          window.location.href = `/discount/FREEPRESS?redirect=${window.location.pathname}?cart=open`;
        }).catch(error => {
          console.error('Error adding item to cart:', error);
        });
        
      }
      
    }).catch();
    
  };

  // init
  assess_cart();

  document.addEventListener('rebuy:cart.change', (event) => { 
    assess_cart(event.detail.cart.subtotal()); 
  });

  document.addEventListener('rebuy:cart.ready', (event) => { 
    // assess_cart(event.detail.cart.subtotal());
  });
  
};

if(window.sessionStorage.getItem("[BRE-01] activate Burger Press GWP") ||
  getParam("free_burger_press") ||
  getParam("utm_campaign").toLowerCase().indexOf("burger press") > -1){
  free_burger_press();
}

window.addEventListener("klaviyoForms", function(e) { 
  console.log("klaviyoForms event", e.detail)
  if (e.detail.type == 'submit' && e.detail.formId == "W2VaPf") {
    free_burger_press();
  }
});
/* END support for [BRE-01] */

/* START support for [BRE-23] */
let activation_param = "pt=firestarter";

const add_item_to_cart = (var_id) =>{
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            items: [
            {
                id: var_id,
                quantity: 1,
                properties: {
                    source: "email signup",
                    _discount: "email signup",
                }
            }
            ]
        })
    }).then(res => res.json()).then(data => {
    console.log('Added to cart:', data);
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    }).catch(err => console.error('Error adding to cart:', err));
}

if(window.sessionStorage.getItem("[BRE-23] in-cart treatment") || window.location.href.indexOf(activation_param) > -1){
    window.sessionStorage.setItem("[BRE-23] in-cart treatment", true);

    

      let review_cart = () => {

        waitForElement('.cart-drawer__line-items').then(cart => {

          let cart_items = cart.querySelectorAll('line-item');
          let show_gwp = false;
          for(let i = 0; i < cart_items.length; i++){
              if(cart_items.length > 0){
                  show_gwp = true;
              }
              if(cart_items[i].innerText.indexOf("source: email signup") > -1){
                  show_gwp = false;
                  break;
              }
          }

          if(show_gwp){
              // an item is in the cart AND not the offer
              console.log("setting it up")
              
              if(document.querySelectorAll('.js-offer').length == 0){
                  cart.insertAdjacentHTML("beforebegin", `
                      <style>
                      .js-offer{
                          background: #e6e4db;
                          margin: 1rem 0;
                          padding: 1rem 1rem 1rem 0;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                      }
                      .js-offer > div:first-child{
                          padding-left: 100px;
                          background: url(https://breeo.com/cdn/shop/files/firestarters-main.png?v=1747254340&width=300) left center no-repeat;
                          background-size: 100px;
                      }
                      .js-offer > div:last-child{
                          text-align: center;
                      }
                      .js-offer > div:last-child span{
                          display: block;
                          font-size: .75rem;
                          margin-top: -.5rem;
                      }
                      .js-offer #gwp-atc{
                          transform: scale(.75)
                      }
                      .button.button--xs{
                        cursor: pointer;
                      }
                      @media(max-width: 525px){
                          .js-offer{
                              display: block;
                          }
                          .js-offer > div:last-child{
                              text-align: left;
                              margin-left: 75px;
                          }        
                          .js-offer #gwp-atc{
                              margin-left: 0;
                          }   
                          .js-offer > div:last-child span{
                              margin-left: 55px;
                          }
                      }
                      </style>
                      <div class="js-offer">
                          <div>
                              Claim your <strong>FREE</strong> Waterproof Fire Starters
                          </div>
                          <div style="min-width: 190px;">
                              <div id="gwp-atc" class="button button--xs">Add to Cart</div>
                              <span>a $20.00 value</span>
                          </div>
                          
                      </div>
                  `)
              }
          } else {
              console.log("tearing it down")
              if(document.querySelectorAll('.js-offer') > 0){
                  document.querySelector('.js-offer').remove();
              }
          }

        }).catch();

      } // review_cart();

      // init
      setTimeout(() => {
          review_cart();
      }, 1500)

      observeSelector('line-item', line_item => {
          review_cart();
      });

      observeSelector('#gwp-atc', gwp_atc => {
          gwp_atc.addEventListener("click", (e) => {
              add_item_to_cart(41451417763885); // firestarters
              gwp_atc.parentNode.style.opacity = 0.5;
              setTimeout(() => {
                  gwp_atc.parentNode.remove();
              }, 750)
          });
      });

    // if activated, BLOCK the popups

    const og_form_id_desktop = "W2VaPf";
    const new_form_id_desktop = "SQYvmN";
    const alt_form_id_desktop = "UmvBFA";

    const select_topmost_ancestor = (element, selector) => {
        if (!element) {
        return null;
        }
    
        // Check if the current element matches the specified selector
        if (!element.closest(selector)) {
        // If it does not match, return the current element
        return element;
        }
    
        // Otherwise, check its parent element recursively
        return select_topmost_ancestor(element.parentElement, selector);
    };

    observeSelector(`form[data-testid="klaviyo-form-${og_form_id_desktop}"], form[data-testid="klaviyo-form-${new_form_id_desktop}"], form[data-testid="klaviyo-form-${alt_form_id_desktop}"]`, kl_form => {
        let popup_container = select_topmost_ancestor(kl_form, '.needsclick[class*="kl-"]')
        popup_container.remove();
        document.body.classList.remove("klaviyo-prevent-body-scrolling");
        setTimeout(() => {
            document.body.classList.remove("klaviyo-prevent-body-scrolling");
        }, 500)
    })

}
/* END support for [BRE-23] */